"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var AnimatedAirplaneStraight_1 = require("./AnimatedAirplaneStraight");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(AnimatedAirplaneStraight_1).default; } });
